import {useEffect, useState} from "react";
import style from "./checkbox.module.scss";
import { ClassNames } from "@emotion/react";

function Checkbox({className,
    disabled,
    inputStyle,
    name,
    onChange,
    readOnly,
    checked,
    placeholder,
    label,
    id="checkbox"
    }) {


    return (
        <div className={[style.input, className].join(" ")}>
            <input
            aria-label={name}
            data-testid={name}
            tabIndex={0}
            type="checkbox"
            name={name}
            onChange={onChange}
            placeholder={placeholder}
            checked={checked}
            style={inputStyle}
            disabled={disabled}
            readOnly={readOnly}
            id={id}
            />
            <label htmlFor={id}>{label}</label>   
        </div>
    );
}

export default Checkbox;
